export default "__VITE_ASSET__CxSZA1Fz__"